import { Clock, RefreshCw, Shield, KeyRound, Grid, Fingerprint, Layers } from "lucide-react";
import { motion } from "framer-motion";

const passwordTypes = [
  { icon: <Clock className="w-5 h-5 text-cyan-600" />, title: "Single-use / OTP", description: "Used once for authentication." },
  { icon: <RefreshCw className="w-5 h-5 text-cyan-600" />, title: "Temporary", description: "Valid for a limited time." },
  { icon: <Shield className="w-5 h-5 text-cyan-600" />, title: "Master / Admin", description: "Strong passwords for critical accounts." },
  { icon: <KeyRound className="w-5 h-5 text-cyan-600" />, title: "Account-specific", description: "Unique passwords for each account." },
  { icon: <Grid className="w-5 h-5 text-cyan-600" />, title: "Graphical / Pattern", description: "Swipe or click patterns for passwords." },
  { icon: <Fingerprint className="w-5 h-5 text-cyan-600" />, title: "Biometric-backed", description: "Combined with fingerprints, face ID, or retina scans." },
  { icon: <Layers className="w-5 h-5 text-cyan-600" />, title: "Batch", description: "Generate multiple passwords at once." },
];

export default function PasswordTypesGrid() {
  return (
    <div className="mt-12 max-w-6xl mx-auto px-4">
      {/* Section Header */}
      <div className="text-center mb-8">
        <h2 className="text-3xl font-bold text-gray-800">Password Types</h2>
        <p className="text-gray-600 mt-2">
          Understand the different types of passwords you can generate with our tool.
        </p>
      </div>

      {/* Grid */}
      <div className="grid md:grid-cols-2 gap-6">
        {passwordTypes.map((type, index) => (
          <motion.div
            key={index}
            className="p-4 border rounded-xl bg-gray-50 shadow-sm hover:shadow-md transition"
            whileHover={{ y: -3, scale: 1.02 }}
            transition={{ type: "spring", stiffness: 200, damping: 10 }}
          >
            <div className="flex items-center gap-3 mb-2">
              {type.icon}
              <h3 className="font-semibold text-gray-800">{type.title}</h3>
            </div>
            <p className="text-sm text-gray-600">{type.description}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
